import React, { useState } from 'react';
import api from '../services/api';

const Disponivel = () => {
  const [data, setData] = useState('');
  const [duracao, setDuracao] = useState(30);
  const [horarios, setHorarios] = useState([]);
  const [loading, setLoading] = useState(false);

  const buscar = async () => {
    if (!data) return;
    setLoading(true);
    try {
      const res = await api.get(`/ia/disponibilidade?data=${data}&duracao_minutos=${duracao}`);
      setHorarios(res.data.horarios_livres || []);
    } catch (err) { console.error(err); } 
    finally { setLoading(false); }
  };

  return (
    <div style={styles.container}>
      <div style={styles.searchCard}>
        <h2 style={styles.title}>Pesquisa de Disponibilidade</h2>
        <div style={styles.searchRow}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Data da Busca</label>
            <input type="date" value={data} onChange={e => setData(e.target.value)} style={styles.input} />
          </div>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Duração (minutos)</label>
            <input type="number" value={duracao} onChange={e => setDuracao(e.target.value)} style={styles.input} />
          </div>
          <button onClick={buscar} style={styles.button}>{loading ? 'Aguarde...' : 'Pesquisar'}</button>
        </div>
      </div>

      <div style={styles.resultsGrid}>
        {horarios.map(h => (
          <div key={h} style={styles.slotCard}>
            <span style={styles.slotTime}>{h}</span>
            <span style={styles.slotAvailable}>Horário Livre</span>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: { padding: '40px 20px', maxWidth: '800px', margin: '0 auto', fontFamily: '"Montserrat", sans-serif', backgroundColor: '#FAF8F5', minHeight: '100vh' },
  searchCard: { backgroundColor: '#FFFFFF', padding: '40px', borderRadius: '12px', border: '1px solid #EBE6E0', marginBottom: '32px' },
  title: { fontSize: '24px', color: '#2C2A29', marginBottom: '24px', fontFamily: '"Playfair Display", serif', fontWeight: '500', textAlign: 'center' },
  searchRow: { display: 'flex', gap: '16px', alignItems: 'flex-end', flexWrap: 'wrap' },
  inputGroup: { flex: 1, minWidth: '150px' },
  label: { fontSize: '11px', fontWeight: '500', color: '#7A7571', marginBottom: '8px', display: 'block', textTransform: 'uppercase', letterSpacing: '0.5px' },
  input: { width: '100%', padding: '14px', borderRadius: '8px', border: '1px solid #EBE6E0', outline: 'none', backgroundColor: '#FCFBF9' },
  button: { padding: '14px 24px', backgroundColor: '#B59978', color: '#FFFFFF', border: 'none', borderRadius: '8px', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '1px', cursor: 'pointer', transition: 'opacity 0.2s' },
  resultsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: '16px' },
  slotCard: { backgroundColor: '#FFFFFF', padding: '16px', borderRadius: '8px', textAlign: 'center', border: '1px solid #EBE6E0', display: 'flex', flexDirection: 'column', gap: '6px' },
  slotTime: { fontSize: '18px', fontFamily: '"Playfair Display", serif', color: '#2C2A29' },
  slotAvailable: { fontSize: '10px', color: '#B59978', textTransform: 'uppercase', letterSpacing: '0.5px' }
};

export default Disponivel;